/*
* Navigation Configuration
*/
export default function () {
  const { $i18n: i18n } = useNuxtApp()
  
  return {
    header: [
      {
        title: 'Products',
        descr: 'All Products',
        link: '/catalog/products',
        submenu: [
          {
            title: 'USB Flash Drives',
            descr: 'USB Flash Drives',
            link: '/catalog/flash-drives-98',
            seeAllTitle: 'All USB Flash Drives',
            submenu: [
              {
                title: 'USB 3 / Type-C',
                descr: 'USB 3.0 and USB Type-C',
                link: '/catalog/usb-3-and-type-c-82',
                icon: '/img/navigation/usb-type-c.svg'
              },
              {
                title: 'Business Cards',
                descr: 'Business Cards',
                link: '/catalog/usb-business-cards-31',
                icon: '/img/navigation/business-cards.svg'
              },
              {
                title: 'Executive Pens',
                descr: 'USB Executive Pens',
                link: '/catalog/usb-executive-pens-30',
                icon: '/img/navigation/usb-pens.svg'
              },
              {
                title: 'Memory Cards',
                descr: 'Custom Flash Memory Cards',
                link: '/catalog/custom-memory-cards-29',
                icon: '/img/navigation/memory-cards.svg'
              },
              {
                title: 'Direct Mail',
                descr: 'Direct Mail and Print Solutions',
                link: '/page/direct-mail-solutions-105',
                icon: '/img/navigation/direct-mail.svg'
              },
              {
                title: 'Packaging',
                descr: 'Packaging',
                link: '/catalog/packaging-97',
                icon: '/img/navigation/packaging.svg'
              }
            ],
            subcontent: [
              {
                label: 'Featured Products',
                title: 'Micro Flip USB Wallet Card',
                descr: 'This credit-card-sized customized flash drive features two extra-large, full-color printing areas, and super-thin housing that allows it to be slipped into any wallet.',
                link: '/product/wallet-card-micro-flip-278',
                image: '/img/navigation/usbbusinesscard_walletcardmicroflip.png'
              },
              {
                label: '',
                title: 'The Key USB Flash Drive',
                descr: 'This key-shaped personalized flash drive features an ultra-thin, rugged design that fits onto any key-ring for convenience and versatility.',
                link: '/product/the-key-79',
                image: '/img/navigation/flashdrive_thekey.png'
              }
            ]
          },
          {
            title: 'Power',
            descr: 'Custom Power Banks, Mobile Chargers, Cables',
            link: '/catalog/power-99',
            seeAllTitle: 'All Power Products',
            submenu: [
              {
                title: 'Power Banks',
                descr: 'Custom Mobile Chargers & Car Chargers',
                link: '/catalog/custom-power-bank-96',
                icon: '/img/navigation/power-banks.svg'
              },
              {
                title: 'Wireless Chargers',
                descr: 'Custom Wireless Qi Chargers',
                link: '/catalog/wireless-chargers-95',
                icon: '/img/navigation/wireless-chargers.svg'
              },
              {
                title: 'Charging Cables',
                descr: 'Custom USB Charging Cables',
                link: '/catalog/custom-charging-cables-116',
                icon: '/img/navigation/usb-cables.svg'
              }
            ],
            subcontent: [
              {
                label: 'Featured Products',
                title: 'PowerTile Glass',
                descr: 'This 5,000mAh mobile charger features a built-in MicroUSB cable with Lightning and Type-C adapters, as well as a tough high-gloss tempered-glass plate that will make your full-color logo look incredible.',
                link: '/product/powertile-glass-306',
                image: '/img/navigation/custom-power-bank-powertile-glass.png'
              },
              {
                label: '',
                title: 'PowerCircle Glass',
                descr: 'This 10-Watt custom wireless charger features a gigantic 4-inch branding surface with a shatterproof, tempered glass plate that will make your logo will look bright, vivid, and extra-crisp.',
                link: '/product/powercircle-glass-310',
                image: '/img/navigation/wireless-chargers-powercircle-glass.png'
              }
            ]
          },
          {
            title: 'Audio',
            descr: 'Custom Earbuds Speakers',
            link: '/catalog/audio-32',
            seeAllTitle: 'All Audio Products',
            submenu: [
              {
                title: 'Custom AirPods',
                descr: 'Custom Apple AirPods VIP Gifts',
                link: '/catalog/airpods-vip-gifts-122',
                icon: '/img/navigation/apple.svg'
              },
              {
                title: 'Wireless Headphones',
                descr: 'Custom Bluetooth True Wireless Headphones',
                link: '/catalog/headphones-earbuds-with-logo-106',
                icon: '/img/navigation/headphones.svg'
              },
              {
                title: 'Bluetooth Speakers',
                descr: 'Custom Bluetooth Speakers',
                link: '/catalog/bluetooth-speakers-105',
                icon: '/img/navigation/speakers.svg'
              }
            ],
            subcontent: [
              {
                label: 'Featured Category',
                title: 'Apple AirPods VIP Gifts',
                descr: 'Completely personal, one-of-a-kind premium Apple AirPods complete with personalized packaging, personal notes, and individualized products all in one step. And, of course, No Minimums.',
                link: '/catalog/airpods-vip-gifts-122',
                image: '/img/navigation/airpods-vip-gifts.png'
              },
              {
                label: 'Featured Product',
                title: 'Stadium Pro Bluetooth Speaker',
                descr: 'This mini bar Bluetooth speaker provides high quality sound with 2 stereo 3-Watt speakers, featuring a large branding area to showcase your logo, slogan, tagline, r full-color photo!',
                link: '/product/stadium-pro-356',
                image: '/img/navigation/bluetooth-speakers-stadium-pro.png'
              }
            ]
          },
          {
            title: 'Drinkware',
            descr: 'Custom Drinkware',
            link: '/catalog/drinkware-109',
            seeAllTitle: 'All Audio Products',
            submenu: [
              {
                title: 'Custom YETI',
                descr: 'Custom YETI VIP Gifts',
                link: '/catalog/yeti-vip-gifts-117',
                icon: '/img/navigation/yeti.svg'
              },
              {
                title: 'Mugs',
                descr: 'Personalized Travel Mugs',
                link: '/catalog/personalized-mugs-110',
                icon: '/img/navigation/mugs.svg'
              },
              {
                title: 'Tumblers',
                descr: 'Custom Tumblers',
                link: '/catalog/custom-tumblers-111',
                icon: '/img/navigation/tumblers.svg'
              },
              {
                title: 'Bottles',
                descr: 'Custom Branded Water Bottles',
                link: '/catalog/branded-water-bottles-112',
                icon: '/img/navigation/bottles.svg'
              },
              {
                title: 'Coasters',
                descr: 'Custom Coasters',
                link: '/catalog/coasters-120',
                icon: '/img/navigation/coasters.svg'
              }
            ],
            subcontent: [
              {
                label: 'Featured Category',
                title: 'YETI Personalized VIP Gifts',
                descr: 'Completely personal, one-of-a-kind premium YETI products complete with personalized packaging, personal notes, and individualized products all in one step. And, of course, No Minimums!',
                link: '/catalog/yeti-vip-gifts-117',
                image: '/img/navigation/yeti-vip-gifts.png'
              },
              {
                label: 'Featured Product',
                title: 'Camper Insulated Mug',
                descr: 'These insulated 12oz or 16.9oz stainless steel mugs with handles and lids are guaranteed to be a coffee-lover\'s new best friend, and yours as they bring you brand impressions everywhere!',
                link: '/product/camper-mug-364',
                image: '/img/navigation/personalized-mugs-camper-mug.png'
              }
            ]
          },
          {
            title: 'Accessories',
            descr: 'Accessories',
            link: '/catalog/accessories-100',
            seeAllTitle: 'All Drinkware',
            submenu: [],
            subcontent: [
              {
                label: 'Featured Category',
                title: 'Custom PopSocket Phone Holders',
                descr: 'This credit-card-sized customized flash drive features two extra-large, full-color printing areas, and super-thin housing that allows it to be slipped into any wallet.',
                link: '/catalog/custom-phone-holders-103',
                image: '/img/navigation/custom-phone-holders.png'
              },
              {
                label: 'Featured Product',
                title: 'QuadroSquare Charging Cable',
                descr: 'These 4-in-1 USB charging cables feature a Standard USB (Type A), microUSB, USB Type-C, and Lightning connectors - plus a large edge-to-edge branding area, to showcase your full-color logo.',
                link: '/product/quadrosquare-charging-cable-384',
                image: '/img/navigation/accessories-quadrosquare-charging-cable.png'
              }
            ]
          }
        ]
      },
      {
        title: '100% Custom Designed',
        descr: '100% Custom Designed"',
        link: '/page/custom-products-2',
        submenu: []
      },
      {
        title: 'Swag Boxes',
        descr: 'Custom Swag Boxes & Swag Kits',
        link: '/catalog/custom-swag-boxes-113',
        submenu: []
      },
      {
        title: 'Corporate Gifts',
        descr: 'Custom Corporate Gift Packs',
        link: '/catalog/corporate-gifts-123',
        submenu: []
      },
      {
        title: 'About Us',
        descr: 'Who We Are',
        link: '/page/contact-92',
        submenu: []
      }
    ],

    footer: [
      {
        title: 'USB Flash Drives',
        link: '/catalog/flash-drives-98',
        descr: 'USB Flash Drives',
        subMenu: [
          {
            title: 'Browse All Models',
            link: '/catalog/flash-drives-98',
            descr: 'All CustomUSB Flash Drives'
          },
          {
            title: 'Rush Delivery',
            link: '/page/rush-45',
            descr: '24hr Production Rush Delivery'
          },
          {
            title: 'USB 3 / Type-C',
            link: '/catalog/usb-3-and-type-c-82',
            descr: 'USB 3.0 and USB Type-C'
          },
          {
            title: 'Executive Pens',
            link: '/catalog/usb-executive-pens-30',
            descr: 'USB Executive Pens'
          },
          {
            title: 'Business Cards',
            link: '/catalog/usb-business-cards-31',
            descr: 'USB Business Cards'
          },
          {
            title: 'Direct Mail',
            link: '/page/direct-mail-solutions-105',
            descr: 'Direct Mail and Print Solutions'
          },
          {
            title: 'Memory Cards',
            link: '/catalog/custom-memory-cards-29',
            descr: 'Custom Flash Memory Cards'
          },
          {
            title: 'No MOQ Flash Drives',
            link: '/catalog/custom-flash-drives-no-minimum-107',
            descr: 'Custom Flash Drives No Minimum Order Quantity'
          }
        ]
      },
      {
        title: 'All Products',
        link: '/calalog/products',
        descr: 'All Products',
        subMenu: [
          {
            title: 'Power Banks',
            link: '/catalog/custom-power-bank-96',
            descr: 'Custom Power Banks, Mobile Chargers, Cables'
          },
          {
            title: 'Wireless Chargers',
            link: '/catalog/wireless-chargers-95',
            descr: 'Custom Wireless Qi Chargers'
          },
          {
            title: 'Charging Cables',
            link: '/catalog/custom-charging-cables-116',
            descr: 'Custom USB Charging Cables'
          },
          {
            title: 'Audio',
            link: '/catalog/audio-32',
            descr: 'Custom Earbuds Speakers'
          },
          {
            title: 'Drinkware',
            link: '/catalog/drinkware-109',
            descr: 'Custom Drinkware'
          },
          {
            title: 'Packaging',
            link: '/catalog/packaging-97',
            descr: 'Packaging'
          }
        ]
      },
      {
        title: 'Services',
        link: '#',
        descr: 'Services',
        subMenu: [
          {
            title: '100% Custom Designed',
            link: '/page/custom-products-2',
            descr: '100% Custom Designeds'
          },
          {
            title: 'Swag Boxes',
            link: '/catalog/custom-swag-boxes-113',
            descr: 'Custom Swag Boxes Swag Kits'
          },
          {
            title: 'Corporate Gifts',
            link: '/catalog/corporate-gifts-123',
            descr: 'Custom Corporate Gift Packs'
          },
          {
            title: 'Licensed Products',
            link: '/page/licensed-products-106',
            descr: 'Licensed Products for Retail Sale'
          },
          {
            title: 'Fulfillment Logistics',
            link: '/page/fulfillment-84',
            descr: 'Fulfillment Logistics'
          },
          {
            title: 'USB Drive Tracking',
            link: '/page/usb-turnkey-85',
            descr: 'USB Drive Tracking'
          },
          {
            title: 'Data Loading Autorun',
            link: '/page/preload-20',
            descr: 'Data Loading, Preload, Autorun'
          }
        ]
      },
      {
        title: 'Solutions',
        link: '#',
        descr: 'Solutions',
        subMenu: [
          {
            title: 'Product Replicas',
            link: '/page/product-launching-36',
            descr: 'Product Replica Solutions'
          },
          {
            title: 'PortableApps',
            link: '/page/portable-apps-61',
            descr: 'PortableApps'
          },
          {
            title: 'Music',
            link: '/page/music-17',
            descr: 'Music Solutions'
          },
          {
            title: 'Educational',
            link: '/page/education-18',
            descr: 'Education Solutions'
          },
          {
            title: 'Medical',
            link: '/page/medical-33',
            descr: 'Medical Solutions'
          },
          {
            title: 'Press Kit',
            link: '/page/press-kit-35',
            descr: 'Press Kit'
          },
          {
            title: 'Photographers',
            link: '/page/custom-usb-drives-for-photographers-116',
            descr: 'Custom USB Flash Drives for Photographers'
          },
          {
            title: 'GildedBox',
            link: 'https://gildedbox.com/',
            descr: 'GildedBox | Relationships are a Gift'
          }
        ]
      },
      {
        title: 'Support',
        link: '#',
        descr: 'Support',
        active: false,
        subMenu: [
          {
            title: 'About Us',
            link: '/page/contact-92',
            descr: 'Who We Are'
          },
          {
            title: 'Artwork Guidelines',
            link: '/page/artwork-guidelines-43',
            descr: 'Artwork Guidelines'
          },
          {
            title: 'Shipping Information',
            link: '/page/shipping-information-71',
            descr: 'Shipping Information'
          },
          {
            title: 'Terms and Conditions',
            link: '/page/terms-and-conditions-129',
            descr: 'Terms and Conditions'
          },
          {
            title: 'Warranty',
            link: '/page/warranty-26',
            descr: 'Warranty'
          },
          {
            title: 'FAQ',
            link: '/page/faq-24',
            descr: 'FAQ'
          }
        ]
      }
    ],

    customer: [
      {
        name: 'dashboard',
        title: i18n?.t('customerRoutes.dashboard'),
        componentName: 'Dashboard',
        link: '/customer',
        icon: 'icon icon-machine-learning',
        enable: false,
        active: true,
        important: true,
        subRoute: false
      },
      {
        name: 'projects',
        title: i18n?.t('customerRoutes.projects'),
        componentName: 'Projects',
        enable: true,
        link: '/customer/projects',
        icon: 'icon icon-gift-exchange',
        active: false,
        important: true,
        subRoute: false
      },
      {
        name: 'campaigns',
        title: i18n?.t('customerRoutes.campaigns'),
        componentName: 'GiftDistribution',
        enable: false,
        link: '/customer/campaigns',
        icon: 'icon icon-archery-target',
        active: false,
        important: true,
        subRoute: /^(?:\d+|create)$/
      },
      {
        name: 'redeem',
        title: i18n?.t('customerRoutes.giftRedeemPage'),
        componentName: 'GiftDistribution',
        enable: false,
        link: '/customer/redeem',
        icon: 'icon icon-gift-exchange',
        active: false,
        important: true,
        subRoute: /^(?:\d+|create)$/
      },
      {
        name: 'project-approvals',
        title: i18n?.t('customerRoutes.GiftProjectApprovals'),
        componentName: 'ProjectsApprovals',
        enable: false,
        link: '/customer/project-approvals',
        icon: 'icon icon-privacy-policy',
        active: false,
        important: true,
        subRoute: false
      },
      {
        name: 'thank-you-notes',
        title: i18n?.t('customerRoutes.thankYouNotes'),
        componentName: 'ThankYouNotes',
        enable: true,
        link: '/customer/thank-you-notes',
        icon: 'icon icon-love-card',
        active: false,
        important: false,
        subRoute: false,
        notification: false,
        isNewBadge: false
      },
      {
        name: 'orders',
        title: i18n?.t('customerRoutes.orderHistory'),
        componentName: 'Orders',
        enable: true,
        link: '/customer/orders',
        icon: 'icon icon-clock-rotate-clockwise',
        active: false,
        important: true,
        subRoute: /^-?\d+(\d+)?$/
      },
      {
        name: 'orders-external',
        title: i18n?.t('customerRoutes.orderExternalHistory'),
        componentName: 'OrdersExternal',
        enable: true,
        link: '/customer/orders-external',
        icon: 'icon icon-api',
        active: false,
        important: true,
        subRoute: /^-?\d+(\d+)?$/,
        isNewBadge: false
      },
      {
        name: 'integrations-and-api',
        title: i18n?.t('customerRoutes.integrationsAndApi'),
        componentName: 'IntegrationsAndApi',
        enable: false,
        link: '/customer/integrations-and-api',
        icon: 'icon icon-api',
        active: false,
        important: false,
        subRoute: false,
        isNewBadge: true
      },
      {
        name: 'team-dashboard',
        title: i18n?.t('companyRoutes.teamOrderHistory'),
        componentName: 'CompanyDashboard',
        enable: false,
        link: '/customer/team-dashboard',
        icon: 'icon icon-conference-room',
        active: false,
        important: true,
        subRoute: false
      },
      {
        name: 'team-campaigns',
        title: i18n?.t('companyRoutes.teamCampaigns'),
        componentName: 'Dashboard',
        link: '/customer/team-campaigns',
        icon: 'icon icon-people-network',
        enable: false,
        active: false,
        important: true,
        subRoute: false
      }
    ],

    setting: [
      {
        name: 'user-management',
        title: i18n?.t('settingRoutes.userManagement'),
        componentName: 'CompanyUserManagement',
        link: '/customer/user-management',
        icon: 'icon icon-crowd-2',
        enable: false,
        active: false,
        important: true,
        subRoute: false
      },
      {
        name: 'information',
        title: i18n?.t('settingRoutes.information'),
        componentName: 'Information',
        enable: true,
        link: '/customer/information',
        icon: 'icon icon-cogwheel',
        active: false,
        important: false,
        subRoute: false
      },
      {
        name: 'payments',
        title: i18n?.t('customerRoutes.payments'),
        componentName: 'Payments',
        enable: true,
        link: '/customer/payments',
        icon: 'icon icon-money-13',
        active: false,
        important: false,
        subRoute: false
      },
      {
        name: 'addresses',
        title: i18n?.t('customerRoutes.addresses'),
        componentName: 'Addresses',
        enable: true,
        link: '/customer/addresses',
        icon: 'icon icon-contacts',
        active: false,
        important: false,
        subRoute: false
      },
      {
        name: 'gallery',
        title: i18n?.t('customerRoutes.gallery'),
        componentName: 'Gallery',
        enable: true,
        link: '/customer/gallery',
        icon: 'icon icon-cloud-upload',
        active: false,
        important: false,
        subRoute: false
      },
      {
        name: 'referrals',
        title: i18n?.t('customerRoutes.referrals'),
        componentName: 'Referrals',
        enable: true,
        link: '/customer/referrals',
        icon: 'icon icon-people-network',
        active: false,
        important: false,
        subRoute: false
      },
      {
        name: 'password',
        title: i18n?.t('settingRoutes.password'),
        componentName: 'Password',
        link: '/customer/password',
        icon: 'icon icon-lock',
        enable: true,
        active: false,
        important: true,
        subRoute: false
      },
      {
        name: 'notifications',
        title: i18n?.t('settingRoutes.notifications'),
        componentName: 'Notifications',
        link: '/customer/notifications',
        icon: 'icon icon-alarm',
        enable: true,
        active: false,
        important: true,
        subRoute: false
      },
      {
        name: 'logout',
        title: i18n?.t('logOut'),
        componentName: false,
        link: '#',
        type: 'action',
        enable: true,
        onClick: () => {},
        icon: 'icon icon-leave',
        active: false,
        important: false,
        subRoute: false,
        isNewBadge: false
      }
    ],

    support: [
      {
        name: 'faq',
        title: i18n?.t('supportRoutes.faq'),
        componentName: 'Faq',
        link: '/faq',
        icon: 'icon icon-circle-info',
        enable: false,
        active: useRuntimeConfig().public.confGlobal.serverType !== 'PROD',
        important: true,
        subRoute: false,
        isNewBadge: true
      }
    ],

    socials: [
      {
        title: 'CustomUSB on Facebook',
        link: 'https://www.facebook.com/customusbdrives',
        icon: 'icon icon-social-media-facebook font-light'
      },
      {
        title: 'CustomUSB on Twitter',
        link: 'https://www.twitter.com/customusb',
        icon: 'icon icon-social-media-twitter font-light'
      },
      {
        title: 'CustomUSB on Instagram',
        link: 'http://www.instagram.com/customusbs',
        icon: 'icon icon-social-instagram font-light'
      },
      {
        title: 'CustomUSB on Pinterest',
        link: 'http://www.pinterest.com/customusbdrives/',
        icon: 'icon icon-social-pinterest font-light'
      }
    ],

    reviews: [
      {
        id: 'shopperapproved',
        link: 'https://www.shopperapproved.com/reviews/customusb.com/'
      },
      {
        id: 'trustpilot',
        link: 'https://www.trustpilot.com/review/customusb.com?utm_medium=trustbox&utm_source=Horizontal'
      }
    ],

    system: [
      {
        id: 'privacy',
        link: '/page/privacy-44'
      },
      {
        id: 'copyright',
        link: '/page/copyright-93'
      },
      {
        id: 'contact',
        link: '/page/contact-92'
      },
      {
        id: 'faq',
        link: '/faq',
        enable: useRuntimeConfig().public.confGlobal.serverType !== 'PROD'
      }
    ]
  }
}
